import {
  CellClassParams,
  ColDef,
  SizeColumnsToContentStrategy,
} from 'ag-grid-enterprise';
import { tooltipValueGetter } from '../tooltipValueGetter';
import { ExtendedRowNode } from '../types';

const maxWidth = 800;

const invalidCellErrorRules = {
  'cell-with-error': (params: CellClassParams) => {
    const node = params.node as ExtendedRowNode;
    return Boolean(node._cellErrors?.[params.colDef.field ?? '']);
  },
};

export const defaultColumnDefinition: ColDef = {
  filter: true,
  editable: false,
  tooltipValueGetter,
  cellClassRules: invalidCellErrorRules,
  maxWidth: maxWidth,
};

export const autosizeStrategy: SizeColumnsToContentStrategy = {
  type: 'fitCellContents',
  defaultMaxWidth: maxWidth,
  // scaleUpToFitGridWidth: true, TODO this property is not yet supported in current version
};
